module.exports = __webpack_public_path__ + "img/bg.36d1193.jpeg";